import { createSlice } from "@reduxjs/toolkit";
import { ConvertDocumentTemplateResponse } from "../../models/convertDocumentTemplate.model";
import { convertDocumentTemplate } from "../thunks/documentParamsThunks";

interface ConvertDocumentTemplateState {
  data: ConvertDocumentTemplateResponse | null;
  loading: boolean;
  error: string | null;
  currentRequestId: string | null;
}

const initialState: ConvertDocumentTemplateState = {
  data: null,
  loading: false,
  error: null,
  currentRequestId: null,
};

const convertDocumentTemplateSlice = createSlice({
  name: "convertDocumentTemplate",
  initialState,
  reducers: {
    clearConvertedDocumentTemplate: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.currentRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(convertDocumentTemplate.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.data = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(convertDocumentTemplate.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return;
        }
        state.loading = false;
        state.data = action.payload;
        state.currentRequestId = null;
      })
      .addCase(convertDocumentTemplate.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
          return;
        }
        state.loading = false;
        state.error = action.payload as string;
        state.currentRequestId = null;
      });
  },
});

export const { clearConvertedDocumentTemplate } =
  convertDocumentTemplateSlice.actions;

export default convertDocumentTemplateSlice.reducer;
